<template>
  <div class="fa">
    <el-card class="box">
      <el-steps :active="active" finish-status="success">
        <el-step title="填写信息"></el-step>
        <el-step title="验证信息"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <el-card class="card-form">
        <div v-show="active == 1">
          <el-form label-width="80px">
            <el-form-item label="账号："
              ><el-input v-model="account_no"></el-input
            ></el-form-item>
            <el-form-item label="找回方式">
              <el-select v-model="value" size="240" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active == 2">
          <div v-show="value==1">
            
          </div>
          <div v-show="value==2">
            <el-form label-width="80px">
              <el-form-item label="验证码：">
                <el-input></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-show="active == 3">3</div>
        <!-- <div v-show="active == 4">4</div> -->
      </el-card>
      <div class="button-bottom">
        <el-button @click="pre">上一步</el-button>
        <el-button @click="goBack">返回</el-button>
        <el-button @click="next">下一步</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import "@/css/global.css";
export default {
  data() {
    return {
      active: 1,
      account_no: "",
      pass_word: "",
      value: "1",
      options: [
        {
          value: "1",
          label: "微信扫码验证"
        },
        {
          value: "2",
          label: "微信通知验证"
        },
        {
          value: "3",
          label: "客服"
        }
      ]
    };
  },
  methods: {
    next() {
      console.log(this.active);

      this.active++;
      console.log(this.active);

      if (this.active > 3) this.active = 3;
    },
    pre() {
      if (this.active-- < 2) this.active = 1;
    },
    goBack() {
      this.$router.push("login");
    }
  }
};
</script>
<style scoped>
.fa {
  background: url(../assets/pic/0001.jpg);
  background-position: center;
  background-attachment: fixed;
  background-size: 100% auto;
  /* padding-top: 100px; */
  height: 100%;
}
.box {
  position: absolute;
  width: 30%;
  /* margin: 30px 0 0 70px; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.el-select {
  width: 100%;
}
.card-form {
  width: 95%;
}
.button-bottom {
  display: flex;
  /* j */
  /* display: flex; */
  justify-content: space-between;
  margin-top: 20px;
}
</style>
